import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { fetchData, deleteData, activateData, TripCustomerfetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

function CollectionPaymentReport() {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [tripId, settripId] = useState();
    const [executiveId, setexecutiveId] = useState('');
    const [Approval, setApproval] = useState([]);
    const [totalApproval, setTotalApproval] = useState(0);
    const [totalDifference, setTotalDifference] = useState(0);
    const [successMessage, setSuccessMessages] = useState("");
    const [errorMessage, setErrorMessages] = useState('');

    // const [Staffcollection, setStaffcollection] = useState();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, userId, token, logout]);

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CollectionPaymentApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setexecutiveId(dataArray[0].SalesManId)
                settripId(dataArray[0].Id)
                setTripOptions(options);

            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleRefreshClick = () => {
        window.location.reload();
    };

    const [filteredData, setFilteredData] = useState([]);
    const handleRouteTypeChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        try {
            const response = await TripCustomerfetchData('CollectionPaymentApi', companyId, selectedOption.value, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                dataArray.forEach(item => { });
                setApproval("");
                setData(dataArray);
                if (dataArray.length > 0) {
                    setFilteredData(response.response_data.filter(item =>
                        (selectedOption ? item.route === selectedOption.value : true)
                    ));
                    console.log(response);

                }

            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
    };

    const handleAmountChange = (e, index) => {
        const value = e.target.value;
        const regex = /^\d*\.?\d*$/; // Regex to allow only numbers and decimal points

        if ((regex.test(value) && value.length <= 8) || value === '') {
            const newAmount = [...Approval];
            newAmount[index] = value;
            setApproval(newAmount);

            // Step 1: Calculate approval total for all rows based on user-entered values
            const approvalTotal = data.reduce((total, row, i) => {
                const approvalValue = parseFloat(newAmount[i]) || 0; // Use entered values only
                return total + approvalValue; // Sum user-entered values for all rows
            }, 0);

            // Step 2: Set the total approval value (user-entered amounts only)
            setTotalApproval(approvalTotal);

            console.log("Approval Total (user-entered):", approvalTotal);
        }
    };

    useEffect(() => {
        const totalRow = data.find((row) => row.PaymentType === 'Total');
        if (totalRow) {
            const diff = totalRow.Actual - totalApproval;
            setTotalDifference(diff);
        }
    }, [data, Approval, totalApproval]);


    // Ensure Staffcollection is initialized as an array
    const [Staffcollection, setStaffcollection] = useState([]);


    const handleDropdownChange = (e, index, rowData) => {
        const selectedValue = e.target.value;
        const selectedAmount = totalDifference; // Take from the difference column total

        // Ensure the array has enough length to accommodate the index
        const updatedStaffCollection = [...Staffcollection];

        // Check if the index is within the bounds of the array
        if (!updatedStaffCollection[index]) {
            updatedStaffCollection[index] = {}; // Initialize the object if undefined
        }

        updatedStaffCollection[index] = {
            collectionRemarkId: selectedValue,
            collectionAmount: selectedValue === '1' ? selectedAmount : 0,
        };

        console.log('Updated StaffCollection:', updatedStaffCollection);

        setStaffcollection(updatedStaffCollection);
    };

   
    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        // Log Staffcollection for debugging
        console.log("Staffcollection:", Staffcollection);
    
        // Create PaymentAndReceipt object
        const PaymentAndReceipt = {
            CompanyId: companyId,
            IsApproval: true,
            UpdatedDate: new Date().toISOString(),
            UpdatedBy : userId,
        };

        const PaymentAndReceiptSale = data.map(item => ({
            TripId: item.PRId
        }));
    
        // Validate and retrieve a single StaffCollectionPayment
        const validStaff = Staffcollection.find(
            (staff) => staff?.collectionAmount !== undefined && staff.collectionRemarkId
        );
    
        console.log("Valid Staff Data:", validStaff);
    
        if (!validStaff) {
            console.error("No valid staff data found. Check the input data.");
            setErrorMessages("No valid staff data found. Please fill in the required fields.");
            setIsLoading(false);
            return;
        }
    
        // Prepare a single StaffCollectionPayment object
        const cashCollectionData = {
            CompanyId: companyId,
            collectionRemarkId: validStaff.collectionRemarkId,
            collectionAmount: validStaff.collectionAmount,
            CreatedBy: userId,
            CreatedDate: new Date().toISOString(),
            TripId: tripId,
            StaffId: executiveId,
            UserTypeId: 0,
        };
    
        // Build the receiptVM object
        const receiptVM = {
            PaymentAndReceipt: PaymentAndReceipt,
            StaffCollectionPayment: cashCollectionData, // Single object
            PaymentAndReceiptSale : PaymentAndReceiptSale
        };
    
        // Debug: Log the payload
        console.log("ReceiptVM Payload:", receiptVM);
    
        try {
            // Send API request
            const response = await updateData('CollectionPaymentApi', `${tripId}`, receiptVM, token);
            console.log('Receipt Updated successfully:', response);
    
            // Success message
            setSuccessMessages("Receipt Updated successfully!");
            setErrorMessages("");
            setIsLoading(false);
    
            // Reload after success
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            // Handle errors
            console.error('Receipt Update error:', error);
            setErrorMessages("Error updating receipt. Please check the input data.");
            setIsLoading(false);
        }
    };
    


    const calculateTotalActual = () => {
        const expenseRow = data.find(row => row.PaymentType === 'Expense');
        const expenseAmount = expenseRow ? parseFloat(expenseRow.Actual || 0) : 0;
        return data
            .filter(row => row.PaymentType !== 'Total' && row.PaymentType !== 'Expense') // Exclude the "Total" and "Expense" rows
            .reduce((sum, row) => sum + parseFloat(row.Actual || 0), 0) - expenseAmount; // Sum up Actual values and subtract expense amount
    };

    return (

        <div className="w-full max-w-sm container mt-6" style={{ maxWidth: '90%' }}>
            <div className='w-full mb-1 flex' style={{ marginTop: '-10px', marginLeft: '10px' }}>
                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    COLLECTION PAYMENT REPORT</h6>
            </div>
            <div className="w-full mb-1 flex justify-between items-center">
                <div className="flex">
                    <div className="flex flex-col mr-4" style={{ width: '300px', marginLeft: '11px' }}>
                        <Select
                            value={selectedTrip}
                            onChange={handleRouteTypeChange}
                            options={tripOptions}
                            placeholder="Select Trip"
                            isSearchable
                        />
                    </div>
                </div>

            </div>


            <div className="flex justify-end">
                <Button
                    style={{
                        backgroundColor: '#C9E9D2',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handleRefreshClick}
                    className="linkcolor"
                >
                    <span>Refresh</span>
                </Button>
                {/* {totalDifference == 0 && ( */}
                {hasCreateTransactionPermission && (
                <Button onClick={submitData} startIcon={<TaskAltIcon />} style={{
                    backgroundColor: '#E8F3D6',
                    color: 'black',
                    height: '36px',
                    marginTop: '-10px',
                    marginLeft: '5px'


                }} disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Approve"}

                </Button>
               )} 

            </div>
            <div className="w-full max-w-sm container mt-6 mx-auto custom-scrollbar" style={{ maxWidth: '100%' }}>
                <style>
                    {`
                    .custom-scrollbar::-webkit-scrollbar {
                        width: 3px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-thumb {
                        background-color: #333;
                        border: 2px solid #555;
                        border-radius: 6px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-track {
                        background-color: #ddd;
                        border-radius: 6px;
                    }
                    `}
                </style>
                <div className="mt-6">
                    {isLoading ? (
                        <CircularProgress />
                    ) : (
                        <React.Fragment>
                            <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto', scrollbarWidth: 'thin', marginTop: '-24px' }}>
                                <Table>
                                    <TableHead sx={{ backgroundColor: '#89A8B2' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'left', width: '100px', color: 'white' }}>Sl.No</TableCell>
                                            <TableCell sx={{ fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'left', width: '100px', color: 'white' }}>Payment Type</TableCell>
                                            <TableCell sx={{ fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'right', width: '10px', color: 'white' }}>Actual</TableCell>
                                            <TableCell sx={{ fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', width: '10px', color: 'white' }}>Approval</TableCell>
                                            <TableCell sx={{ fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', width: '100px', color: 'white' }}>Difference</TableCell>

                                        </TableRow>
                                    </TableHead>

                                    <TableBody style={{ backgroundColor: '#FBFBFB', color: 'black' }}>
                                        {Array.isArray(data) && data.length > 0 ? (
                                            data.map((rowData, index) => (
                                                <TableRow
                                                    key={rowData.id}
                                                    className={rowData.PaymentType === 'Total' ? 'highlighted-row' : ''}
                                                    sx={{
                                                        height: '52px',
                                                        fontSize: '18px',
                                                        backgroundColor:
                                                            rowData.PaymentType === 'Total'
                                                                ? '#ECEBDE'
                                                                : rowData.PaymentType === 'Expense'
                                                                    ? '#B4D6CD'
                                                                    : 'transparent',
                                                        color:
                                                            rowData.PaymentType === 'Total'
                                                                ? 'white'
                                                                : rowData.PaymentType === 'Expense'
                                                                    ? 'black'
                                                                    : 'inherit',
                                                    }}
                                                >
                                                    {/* Serial Number Cell */}
                                                    <TableCell
                                                        sx={{
                                                            fontWeight: 'bolder',
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            textAlign: 'left',
                                                            width: '100px',
                                                        }}
                                                    >
                                                        {rowData.PaymentType === 'Total' ? (
                                                            <span style={{ fontSize: '16px' }}>0</span>
                                                        ) : (
                                                            index + 1
                                                        )}
                                                    </TableCell>

                                                    {/* Payment Type Cell */}
                                                    <TableCell
                                                        sx={{
                                                            fontWeight: 'bolder',
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            width: '100px',
                                                            textAlign: 'left',
                                                        }}
                                                    >
                                                        <span style={{ fontSize: rowData.PaymentType === 'Total' ? '16px' : 'inherit' }}>
                                                            {rowData.PaymentType}
                                                        </span>
                                                    </TableCell>

                                                    {/* Actual Amount Cell */}
                                                    <TableCell
                                                        sx={{
                                                            fontWeight: 'bolder',
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            width: '100px',
                                                            textAlign: 'right',
                                                        }}
                                                    >
                                                        {rowData.PaymentType === 'Expense' ? (
                                                            <span style={{ fontSize: '16px' }}>-</span>
                                                        ) : rowData.PaymentType === 'Total' ? (
                                                            <span style={{ fontSize: '16px' }}>
                                                                {calculateTotalActual().toFixed(2)}
                                                            </span>
                                                        ) : (
                                                            (rowData.Actual || 0).toFixed(2)
                                                        )}
                                                    </TableCell>


                                                    <TableCell
                                                        sx={{
                                                            fontWeight: 'bolder',
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            width: '10px',
                                                            textAlign: 'right',
                                                        }}
                                                    >
                                                        {rowData.PaymentType === 'Total' ? (
                                                            <span style={{ fontSize: '16px' }}>{totalApproval.toFixed(2)}</span>
                                                        ) : rowData.PaymentType === 'Expense' ? (
                                                            <span style={{ fontSize: '16px' }}>
                                                                {rowData.Actual?.toFixed(2) || '0.00'}
                                                            </span>
                                                        ) : (
                                                            <input
                                                                name="Approval"
                                                                value={Approval[index] || ''}
                                                                onChange={(e) => handleAmountChange(e, index)}
                                                                type="text"
                                                                min="0"
                                                                autoComplete="off"
                                                                style={{ textAlign: 'right', width: '250px' }}
                                                                disabled={rowData.PaymentType === 'Expense' || !rowData.Actual}
                                                            />
                                                        )}
                                                    </TableCell>




                                                    {/* Difference or Dropdown Cell */}
                                                    <TableCell
                                                        sx={{
                                                            fontWeight: 'bolder',
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            width: '100px',
                                                            textAlign: 'right',
                                                        }}
                                                    >
                                                        {rowData.PaymentType === 'Total' ? (
                                                            <span style={{ fontSize: '16px' }}>
                                                                {totalDifference.toFixed(2)}
                                                            </span>
                                                        ) : Approval[index] > 0 ? (
                                                            isNaN(rowData.Actual - Approval[index])
                                                                ? '0.00'
                                                                : (rowData.Actual - Approval[index]).toFixed(2)
                                                        ) : (
                                                            '0.00'
                                                        )}

                                                        {/* Dropdown for Cash Payment Type */}
                                                        {rowData.PaymentType === 'Cash' && rowData.Actual !== Approval[index] && (
                                                            <div
                                                                style={{
                                                                    marginTop: '-15px',
                                                                    textAlign: 'center',
                                                                    height: '100%',
                                                                    width: '50%',
                                                                }}
                                                            >
                                                                <select
                                                                    style={{
                                                                        width: '150px',
                                                                        textAlign: 'center',
                                                                        borderRadius: '10px',
                                                                    }}
                                                                    onChange={(e) => handleDropdownChange(e, index, rowData)}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="1">Equal</option>
                                                                    <option value="2">Short</option>
                                                                    <option value="3">Excess</option>
                                                                </select>
                                                            </div>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={9} sx={{ textAlign: 'center', fontWeight: 'bolder' }}>
                                                    No data available.
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div >
    );
};
export default CollectionPaymentReport;
